// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kJ-h","delete":"styles_delete__3jGjR","update":"styles_update__hPAoy","add":"styles_add__2VFou"};